import { useTabFilter } from './tab-filter.controller';

export interface TabFilterProps {
    onChange?: (value: string) => void;
    keys: string[];
    /**
     * displayMap key should match the keys prop.
     */
    displayMap: Map<string, React.ReactNode>;
    /**
     * Optional map to return a different key than the one used in keys.
     * If not provided, the keys will be used as is.
     */
    returnMap?: Map<string, string>;
    defaultActive?: string;
    useQueryParams?: {
        key: string;
    };
    /**
     * Optional array of query param keys to clear when switching tabs.
     * This keeps tabs isolated from each other's filters.
     */
    filterKeys?: string[];
}

export const TabFilter = (props: TabFilterProps) => {
    const viewProps = useTabFilter(props);
    const styles = {
        active: 'bg-brand-light text-brand-secondary',
        default: 'bg-background-surface hover:cursor-pointer hover:bg-brand-light hover:text-brand-secondary text-brand-muted'
    };
    return (
        <div
            id='tab-filter'
            className='inline-flex items-center justify-start gap-3'>
            {props.keys.map((key) => (
                <div
                    key={key}
                    onClick={() => {
                        if (viewProps.active === key) return;
                        props.onChange?.(props.returnMap && props.returnMap.has(key) ? props.returnMap.get(key)! : key);
                        viewProps.setActive(key);
                    }}
                    className={`${viewProps.active === key ? styles.active : styles.default} outline-border-default flex items-center justify-start gap-2 rounded-xl px-6 py-4 outline-1 outline-offset-[-1px]`}>
                    <span className='justify-start text-base font-semibold'>{props.displayMap.get(key)}</span>
                </div>
            ))}
        </div>
    );
};
